<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n({ useScope: 'global' });

defineProps({
    customerData: {
        type: Object,
        required: true
    },
    showPhone: {
        type: Boolean,
        default: false
    },
    variant: {
        type: String,
        default: 'flat'
    }
});
</script>

<template>
    <v-card v-if="customerData" variant="flat" class="customer-summary">
        <v-card-text class="pa-0">
            <v-row>
                <v-col cols="3" class="pa-3">
                    <div class="summary-label">
                        {{ t('Customer Number') }}
                    </div>
                    <div class="summary-value">
                        {{ customerData?.number || 'N/A' }}
                    </div>
                </v-col>
                <v-col cols="3" class="pa-3">
                    <div class="summary-label">
                        {{ t('Customer Name') }}
                    </div>
                    <div class="summary-value">
                        {{
                            customerData?.fullName ||
                            `${customerData?.name || ''} ${customerData?.lastName || ''}`.trim() ||
                            'N/A'
                        }}
                    </div>
                </v-col>
                <v-col cols="3" class="pa-3">
                    <div class="summary-label">
                        {{ t('Customer Email') }}
                    </div>
                    <div class="summary-value">
                        {{ customerData?.email || 'N/A' }}
                    </div>
                </v-col>
                <v-col v-if="showPhone" cols="3" class="pa-3">
                    <div class="summary-label">
                        {{ t('Customer Phone') }}
                    </div>
                    <div class="summary-value">
                        {{
                            customerData?.phone || customerData?.mobile || 'N/A'
                        }}
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<style scoped>
.customer-summary {
    border-radius: 8px;
}

.summary-label {
    font-size: 0.9rem;
    font-weight: 600;
    color: rgb(var(--v-theme-primary));
    margin-bottom: 4px;
}

.summary-value {
    font-size: 0.95rem;
    line-height: 1.4;
    overflow-wrap: break-word;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .summary-label {
        font-size: 0.85rem;
    }

    .summary-value {
        font-size: 0.9rem;
    }
}
</style>
